import { useState } from 'react';
import toast from 'react-hot-toast';
import { benchmarkService } from '../../services/benchmarkService';

interface ExportButtonsProps {
  runId: string;
  disabled?: boolean;
}

export function ExportButtons({ runId, disabled }: ExportButtonsProps) {
  const [exporting, setExporting] = useState(false);

  const handleExport = async (format: 'csv' | 'xlsx') => {
    try {
      setExporting(true);

      const blob = format === 'csv'
        ? await benchmarkService.exportCsv(runId)
        : await benchmarkService.exportExcel(runId);

      // Create download link
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `benchmark_${runId.slice(0, 8)}.${format}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      toast.success(`Export ${format.toUpperCase()} réussi`);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Export failed');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => handleExport('csv')}
        disabled={disabled || exporting}
        className="px-4 py-2 bg-white border rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
      >
        <span>📥</span>
        <span className="text-sm font-medium">CSV</span>
      </button>

      <button
        onClick={() => handleExport('xlsx')}
        disabled={disabled || exporting}
        className="px-4 py-2 bg-white border rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
      >
        <span>📥</span>
        <span className="text-sm font-medium">Excel</span>
      </button>
    </div>
  );
}
